import React from 'react';
import '../../App.css';
import '../HeroSection.css';



function About() {
    return (
        <>
            <div className='hero-container leadership half'>
                <h1></h1>
            </div>
        </>
    );
}

export default About;